import { useMutation, useQueryClient } from "react-query";

import { documentTemplateService } from "@services/document-templates-service";
import { documentTemplatesQueryKeys } from "./queryKeys";
import { UpdateDocumentTemplatesGroupData } from "@interfaces/company/document-templates";

export const useUpdateDocumentTemplatesGroupMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: UpdateDocumentTemplatesGroupData) =>
      documentTemplateService.updateGroup(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(documentTemplatesQueryKeys.all);
      },
    }
  );
};
